<template>
	<el-container class="register-view">
		<el-form :model="registerForm" status-icon :rules="rules" ref="registerForm" label-width="80px"
			class="web-ruleForm">
			<div class="register-brand">
				<!-- <img class="logo" src="../../public/logo.png" /> -->
				<div>BizSpring</div>
			</div>
			<el-form-item label="电话" prop="userName">
				<el-input type="userName" v-model="registerForm.userName" autocomplete="off"
					placeholder="电话"></el-input>
			</el-form-item>
			<el-form-item label="尊称" prop="nickName">
				<el-input type="nickName" v-model="registerForm.nickName" autocomplete="off"
					placeholder="尊称"></el-input>
			</el-form-item>
			<el-form-item label="公司名称" prop="companyName">
				<el-input type="companyName" v-model="registerForm.companyName" autocomplete="off"
					placeholder="公司名称"></el-input>
			</el-form-item>
			<el-form-item label="邮箱" prop="email">
				<el-input type="email" v-model="registerForm.email" autocomplete="off" placeholder="邮箱"></el-input>
			</el-form-item>
			<el-form-item v-show="vshow" label="密码" prop="password">
				<el-input type="password" v-model="registerForm.password" autocomplete="off"
					placeholder="密码"></el-input>
			</el-form-item>
			<el-form-item v-show="vshow" label="确认密码" prop="confirmPassword">
				<el-input type="password" v-model="registerForm.confirmPassword" autocomplete="off"
					placeholder="确认密码"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm('registerForm')">确定</el-button>
				<el-button @click="resetForm('registerForm')">清空</el-button>
			</el-form-item>
			<div class="to-login">
				<router-link to="/login">已有账号,前往登录</router-link>
			</div>
		</el-form>
		<icp></icp>
	</el-container>
</template>

<script>
import Icp from '../components/common/Icp.vue'
export default {
	name: "login",
	components: {
		Icp
	},
	data() {
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkNickName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入昵称'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};

		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			if (value != this.registerForm.password) {
				return callback(new Error('两次密码输入不一致'));
			}
			callback();
		};


		return {
			queryParams: {},
			routeParams: {},
			registerForm: {
				userName: '',
				nickName: '',
				password: '111111',
				confirmPassword: '111111',
				companyName: '',
				email: ''
			},
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: ''
			},
			vshow: false,
			rules: {
				userName: [{
					validator: checkUserName,
					trigger: 'blur'
				}],
				nickName: [{
					validator: checkNickName,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	created() {
		this.queryParams = this.$route.query;
		this.routeParams = this.$route.params;
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$http({
						url: "/register",
						method: 'post',
						data: this.registerForm
					}).then((data) => {
						// this.login();
						// this.$message.success("提交成功!");

						this.loginForm.userName = this.registerForm.userName;
						this.loginForm.password = this.registerForm.password;

						// if (valid) {
						this.$http({
							url: "/login",
							method: 'post',
							data: this.loginForm
						}).then((data) => {
							// 保存密码到cookie(不安全)
							this.setCookie('username', this.loginForm.userName);
							this.setCookie('password', this.loginForm.password);
							// 保存token
							sessionStorage.setItem("accessToken", data.accessToken);
							sessionStorage.setItem("refreshToken", data.refreshToken);

							this.$message.success("提交成功");

							//进入会话带目标用户id
							if (this.queryParams && this.queryParams.toUserName) {
								this.openChat();
							} else {
								this.$router.push("/home/chat");
							}
						})
					}).catch((e) => {
						if (e && '10003' == e.code) {
							this.loginForm.userName = this.registerForm.userName;
							this.loginForm.password = this.registerForm.password;
							//这里直接登录
							this.$http({
								url: "/login",
								method: 'post',
								data: this.loginForm
							}).then((data) => {
								//登录后跳转链接用户名
								// 保存密码到cookie(不安全)
								this.setCookie('username', this.loginForm.userName);
								this.setCookie('password', this.loginForm.password);
								// 保存token
								sessionStorage.setItem("accessToken", data.accessToken);
								sessionStorage.setItem("refreshToken", data.refreshToken);
								this.openChat();
							})
						}
					})
					this.$message.success("提交成功");
				}
			});
		},

		openChat() {
			this.$http({
				url: "/user/findByName",
				method: "get",
				params: {
					name: this.queryParams.toUserName
				}
			}).then((data) => {
				if (data && data[0] && data[0].id) {
					let user = data[0];
					let chat = {
						type: 'PRIVATE',
						targetId: user.id,
						showName: user.nickName,
						headImage: user.headImageThumb,
					};
					this.$store.commit("openChat", chat);
					this.$store.commit("activeChat", 0);
					this.$router.push("/home/chat");
				}
			})
		},

		setCookie(name, value) {
			document.cookie = name + "=" + escape(value);
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
}
</script>

<style scoped lang="scss">
.register-view {
	position: fixed;
	display: flex;
	justify-content: space-around;
	align-items: center;
	width: 100%;
	height: 100%;
	background: rgb(232, 242, 255);

	.web-ruleForm {
		// width: 500px;
		// height: 550px;
		width: 100%;
		height: 100%;
		padding: 50px;
		background: white;
		opacity: 0.9;
		box-shadow: 0px 0px 1px #ccc;
		border-radius: 3px;
		overflow: hidden;
		border-radius: 3%;

		.register-brand {
			display: flex;
			justify-content: center;
			align-items: center;
			line-height: 50px;
			margin: 20px 0 30px 0;
			font-size: 22px;
			font-weight: 600;
			letter-spacing: 2px;
			text-align: center;
			text-transform: uppercase;

			.logo {
				width: 30px;
				height: 30px;
				margin-right: 10px;
			}
		}

		.to-login {
			display: flex;
			flex-direction: row-reverse;
			line-height: 40px;
			text-align: left;
			padding-left: 20px;
		}
	}
}
</style>
